import React from "react";
import {
  Button,
  ButtonGroup,
  Form,
  FormControl,
  InputGroup,
  ToggleButton,
} from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AppTable from "../../Components/AppTable";
import AccountDetails from "../AccountsScreen/AccountDetails";
import PrintCustomerReceipt from "../AccountsScreen/PrintCustomerReceipt";

const SCREEN_NAME = "REPORTS_SCREEN";

class PaidUnpaidAccountsInner extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      accountType: "deposit",
      mode: "unpaid",
    };

    const columns = [
      {
        value: "sl",
        label: "Sl No",
        render: ({ index }) => index + 1,
      },
      {
        value: "account.shortId",
        label: "Account ID",
        render: ({ item }) => (
          <div
            className="hoveredlink"
            onClick={(e) => {
              e.stopPropagation();
              this.setAsyncState({
                visibleModal: "accountDetails",
                modalData: { account: item },
              });
            }}
          >
            {item?.shortId}
          </div>
        ),
      },
      {
        value: "name",
        label: "Name",
        render: ({ item }) => getFullName(item.customer),
      },
      {
        value: "accountType",
        label: "Account Type",
      },
      {
        value: "collector",
        label: "Collector",
        render: ({ item }) => getFullName(item.collector),
      },
      {
        value: "interestRate",
        label: "Interest Rate",
        render: ({ item }) => (
          <div className="numeric">{item.interestRate}%</div>
        ),
        // hideInMobile: true,
      },
      {
        value: "totalPaid",
        label: "Total Paid",
        render: ({ item }) => (
          <RenderAmount value={item?.reports?.total?.toFixed(2) || 0} />
        ),
      },
      {
        value: "currentBalance",
        label: "Current Balance",
        render: ({ item }) => <RenderAmount value={item?.balance || 0} />,
      },
      {
        value: "endingDate",
        label: "Ending Date",
        render: ({ item }) =>
          item.endingDate
            ? new Date(item.endingDate).toLocaleDateString()
            : null,
        hideInMobile: true,
      },
      {
        value: "actions",
        label: "Actions",
        render: ({ item, index }) => (
          <div style={{ textAlign: "center" }}>
            {item?._id !== "total" ? (
              <Button
                size="sm"
                variant="secondary"
                disabled={!item?._id}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setAsyncState({
                    visibleModal: "customerReceipt",
                    modalData: { account: item, index },
                  });
                }}
              >
                Receipt
              </Button>
            ) : null}
          </div>
        ),
      },
    ];

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
    this.loadAgents();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });
      const res = await api.get("v1/report/paidunpaid", {
        range0,
        range1,
        accountsWhere: this.state.selectedAgent
          ? {
              accountType: this.state.accountType,
              collector: this.state.selectedAgent,
            }
          : { accountType: this.state.accountType },
        transactionsWhere: {
          transactionType:
            this.state.accountType === "loan"
              ? "recovery"
              : this.state.accountType === "deposit"
              ? "deposit"
              : "",
        },
        mode: this.state.mode,
      });

      const total = {
        _id: "total",
        customer: { firstName: "Total" },
        reports: {
          total: res.accounts
            .map((x) => x.reports?.total || 0)
            .reduce((a, b) => a + b, 0),
        },
        balance: res.accounts
          .map((x) => x.balance || 0)
          .reduce((a, b) => a + b, 0),
        interestRate: (
          res.accounts
            .map((x) => x.interestRate || 0)
            .reduce((a, b) => a + b, 0) / (res.accounts.length || 1)
        ).toFixed(2),
      };

      this.setAsyncState({
        data: { ...res, accounts: [total, ...res.accounts] },
        loading: false,
      });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  async loadAgents() {
    try {
      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({}),
      });
      this.setAsyncState({ agents });
    } catch (e) {
      console.error("Error loading agents: ", e.message);
    }
  }

  render() {
    const {
      state: {
        month,
        year,
        loading,
        error,
        visibleModal,
        modalData,
        accountType,
        mode,
        agents,
        selectedAgent,
      },
      props: { title },
    } = this;

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">{title || "Paid/Unpaid Accounts"}</div>
          </div>
          <div className="right">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  value={month || ""}
                  onChange={(e) => this.setState({ month: e.target.value })}
                  as="select"
                  required
                >
                  <option value="">Select Month</option>
                  {this.months.map((x, i) => (
                    <option key={i} value={i}>
                      {x}
                    </option>
                  ))}
                </FormControl>
                <FormControl
                  type="number"
                  value={year || ""}
                  onChange={(e) => this.setState({ year: e.target.value })}
                  placeholder="Year"
                  required
                />

                <Button disabled={loading} type="submit">
                  Load
                </Button>
              </InputGroup>
            </Form>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <FormControl
            as="select"
            style={{
              // padding: "0.5rem 0px",
              margin: "0 0.25rem",
              width: '10rem'
            }}
            value={selectedAgent || ""}
            onChange={(e) =>
              this.setAsyncState({ selectedAgent: e.target.value }).then(() =>
                this.onSubmit()
              )
            }
          >
            <option value="">All Agents</option>
            {agents?.map((x) => (
              <option key={x._id} value={x._id}>
                {getFullName(x)}
              </option>
            ))}
          </FormControl>

          <ButtonGroup className="m-1">
            {["paid", "unpaid"].map((radio) => (
              <ToggleButton
                key={`paidunpaid-mode-${radio}`}
                id={`paidunpaid-mode-${radio}`}
                type="radio"
                variant="outline-success"
                name="paidunpaid-mode"
                value={radio}
                checked={mode === radio}
                onChange={(e) =>
                  this.setAsyncState({ mode: e.currentTarget.value }).then(() =>
                    this.onSubmit()
                  )
                }
                disabled={loading}
              >
                {_.startCase(radio)}
              </ToggleButton>
            ))}
          </ButtonGroup>
          <ButtonGroup className="m-1">
            {["loan", "deposit"].map((radio) => (
              <ToggleButton
                key={`paidunpaid-accounttype-${radio}`}
                id={`paidunpaid-accounttype-${radio}`}
                type="radio"
                variant="outline-success"
                name="paidunpaid-accounttype"
                value={radio}
                checked={accountType === radio}
                onChange={(e) =>
                  this.setAsyncState({
                    accountType: e.currentTarget.value,
                  }).then(() => this.onSubmit())
                }
                disabled={loading}
              >
                {_.startCase(radio)}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>

        <div>
          <AppTable
            {...{
              items: this.state.data?.accounts || [],
              loading,
              error,
              table: {
                columns: this.columns,
                getStyle: ({ item }) =>
                  item._id === "total"
                    ? { color: "blue", fontWeight: "bold" }
                    : null,
                // onRowClick: ({ item, index }) =>
                //   this.setAsyncState({
                //     visibleModal: "transactionDetails",
                //     modalData: { transaction: item, index },
                //   }),
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />

        <PrintCustomerReceipt
          {...{
            key: `customerReceipt-${
              visibleModal === "customerReceipt"
                ? modalData?.account?._id?.toString() || "null"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "customerReceipt",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            accounts: this.state.data?.accounts,
            loadMore: () => this.setAsyncState({ triggerLoadMore: Date.now() }),
            multipleAccounts: true,
            ...(modalData || {}),
          }}
        />
      </div>
    );

    return content;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const PaidUnpaidAccounts = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaidUnpaidAccountsInner);

export default PaidUnpaidAccounts;
